import { render, staticRenderFns } from "./UserFamilyUpdate.vue?vue&type=template&id=3bad059c&"
import script from "./UserFamilyUpdate.vue?vue&type=script&lang=js&"
export * from "./UserFamilyUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports